import { Link } from 'react-router-dom';
import { useVouchingCredits } from '../../../hooks/useVouchingCredits';
import './VouchButton.scss';

interface Props {
  targetUserId: string;
  targetUsername: string;
  viewerUserId?: string | null;
}

export function VouchButton({
  targetUserId,
  targetUsername,
  viewerUserId,
}: Props) {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { available } = useVouchingCredits();

  if (!enabled) return null;
  if (!viewerUserId || viewerUserId === targetUserId) return null;
  if (available < 1) return null;

  return (
    <Link
      className="vouch-button"
      to={`/vouch?user=${encodeURIComponent(targetUsername)}`}
    >
      Vouch for @{targetUsername}
    </Link>
  );
}
